import React, { useState } from "react";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { ExportFile } from "hooks/FileHandler";

const ButtonExportExcel = ({
  icon = <DownloadOutlined />,
  text,
  className = "",
  fetchApi,
  fields = [],
  getFileName,
  pageSize = 100,
  maxPages = 500,
  translate = (v) => v,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { onExportExcel } = ExportFile();

  const handleClick = async () => {
    if (isLoading || typeof fetchApi !== "function") return;

    setIsLoading(true);

    let pageIndex = 0;
    let results = [];

    try {
      while (pageIndex < maxPages) {
        const response = await fetchApi({
          skip: pageIndex * pageSize,
          limit: pageSize,
        });
        const page = response?.data || [];
        if (!page.length) break;

        results = results.concat(page);
        pageIndex += 1;
      }

      // Gắn STT + áp dụng format riêng cho từng field (nếu có)
      const exportData = results.map((item, idx) => {
        const row = { ...item, index: idx + 1 };

        fields.forEach((field) => {
          if (typeof field.format === "function") {
            row[field.key] = field.format(row[field.key], row, translate);
          }
        });

        return row;
      });

      onExportExcel({
        fieldApi: fields.map((field) => field.key),
        fieldExport: fields.map((field) => translate(field.labelKey)),
        data: exportData,
        informationColumn: [],
        timeWait: 0,
        nameFile: typeof getFileName === "function" ? getFileName() : "export.xlsx",
      });
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => setIsLoading(false), 500);
    }
  };

  return (
    <Button
      icon={icon}
      onClick={handleClick}
      loading={isLoading}
      className={`d-flex align-items-center gap-1 ${className}`}
    >
      {text}
    </Button>
  );
};

export default ButtonExportExcel;